import * as v1 from './v1';

/** One version's rules: every rule a player's view of a game needs, and the dictionary version it plays with. */
export type SharedRules = typeof v1 & { version: number };

/** What each rules version changed. A new version adds an entry; an old one never changes. */
export type RulesVersionEntry = {
  version: number;
  /** When it was released, `YYYY-MM-DD`. */
  released: string;
  /** The dictionary version its words are checked with. */
  dictionaryVersion: number;
  /** What it changed. */
  changes: string;
  /** An optional semantic version, for anyone who wants one. */
  semver?: string;
};

/** The versions log, oldest first. */
export const RULES_VERSIONS: readonly RulesVersionEntry[] = [
  {
    version: 1,
    released: '2026-10-28',
    dictionaryVersion: v1.DICTIONARY_VERSION,
    changes:
      'The first rules: an 11 × 11 board in three shapes, racks of 8 characters, the move rules of docs/game-rules.md ' +
      'section 3, 2W and 3W premiums, a 50-point bingo, swapping under ends-turn or then-play, and the end of the game ' +
      'on going out or four scoreless turns.',
    semver: '1.0.0',
  },
];

/** The newest rules version: the one a new game is created under. */
export const RULES_VERSION = 1;

const RULES: ReadonlyMap<number, SharedRules> = new Map([[1, { ...v1, version: 1 }]]);

/**
 * A rules version's rules, or `undefined` when this build doesn't have them. A client that gets `undefined` stops
 * checking moves locally and leaves the server to decide.
 */
export const findRules = (version: number): SharedRules | undefined => RULES.get(version);

/** A rules version's rules. Throws a `RangeError` for a version this build doesn't have. */
export function rulesFor(version: number): SharedRules {
  const rules = findRules(version);
  if (!rules) throw new RangeError(`Unknown rules version: ${version}. Known versions run from 1 to ${RULES_VERSION}`);
  return rules;
}
